// extracted by mini-css-extract-plugin
module.exports = {"home-layout":"home_home-layout__cHILg","banner-layout":"home_banner-layout__84BNM","title":"home_title__2yfTy","ads-layout":"home_ads-layout__oyUfw"};